// extracted by mini-css-extract-plugin
var _1 = "EmailSearchItem-moduleEmailSearchItem__YvbJj SearchItem-moduleSearchItem__qpbuZ";
export { _1 as "EmailSearchItem" }
